/**
 * 객체 설정 > 주소 객체 Store
 *
 * @since 2018-06-14
 * @author kdydesign.kim
 */

// TAMS
import {ObjectSecProfileApiPrefix as objApiPrefix, CmApiPrefix as cmApiPrefix} from 'utils'
// utils
import {
  // computedGetNetworkData,
  // computedSetNetworkData,
  getAddrObjType,
  getAddrVersion,
  objectSetDataParser,
  // TAMS
  parseAddrObjectTypeNumber,
  parseAddrObjectIpVersionType
} from 'objectSettingsUtils'
// <editor-fold desc="Util Function">
// 호스트 객체 데이터
// TAMS
const hostData = () => {
  return {
    // TAMS
    addr_obj_uname: void 0,
    addr_obj_ip_ver_type: 4,
    addr_obj_desc: void 0,
    addr_obj_type: 1,
    addr_obj_ip_start_ip: null,
    addr_obj_ip_end_ip: null,
    addr_obj_ip_mask: null,
    cfg_layer: 1
  }
}

// 네트워크 객체 데이터
const networkData = () => {
  return {
    // TAMS
    addr_obj_uname: void 0,
    addr_obj_ip_ver_type: 4,
    addr_obj_desc: void 0,
    addr_obj_type: 2,
    // ipRange: {
    //   ip1: null,
    //   ip2: null
    // },
    // ipAddress: {
    //   ip: null,
    //   netmask: null
    // },
    addr_obj_ip_start_ip: null,
    addr_obj_ip_end_ip: null,
    addr_obj_ip_mask: null,
    cfg_layer: 1
  }
}

// 그룹 객체 데이터
const groupData = () => {
  return {
    addr_obj_id: 1,
    addr_obj_uname: void 0,
    addr_obj_type: 4,
    addr_obj_desc: void 0,
    mmbr_obj: []
  }
}

// </editor-fold>

export const state = () => ({
  addressApi: `${cmApiPrefix}/objects/ips/addr`,
  hostData: hostData(),
  networkData: networkData(),
  groupData: groupData(),
  addressObjectDataList: [],
  selectedData: void 0,
  parentMenu: '' // SSL 정책설정 메뉴에서 직접입력시 메뉴명 추가할때 사용
})

export const mutations = {
  addressClear (state) {
    state.addressObjectDataList = []
    state.parentMenu = ''
    state.selectedData = void 0
  },
  // 실행되는 메뉴 설정
  setParentMenu (state, data) {
    state.parentMenu = data
  },

  // 주소 객체 선택
  selectedObjectData (state, data) {
    state.selectedData = data
  },

  // 선택된 객체 초기화
  resetAddressSelectedData (state) {
    state.selectedData = void 0
  },

  // 주소 객체 초기화
  resetAddressObjData (state) {
    state.hostData = hostData()
    state.networkData = networkData()
    state.groupData = groupData()
  },

  // 주소 객체 목록 조회
  setAddressObjectList (state, data) {
    state.addressObjectDataList = Object.freeze(_.map(data, (obj) => {
      return objectSetDataParser(obj)
    }))
    data = Object.freeze(data)
  },

  // 주소 객체 목록 초기화
  resetAddressObjectDataList (state) {
    state.addressObjectDataList = []
  },

  // 주소 객체 삭제
  deleteAddressObjectData (state, {objectId}) {
    const addressObjectDataList = _.cloneDeep(state.addressObjectDataList)
    const itemIndex = _.findIndex(state.addressObjectDataList, {addr_obj_id: objectId})

    addressObjectDataList.splice(itemIndex, 1)

    state.addressObjectDataList = Object.freeze(addressObjectDataList)
  },

  // 주소 객체 일괄 삭제
  deleteBatchAddressObjectData (state, {items}) {
    const addressObjectDataList = _.cloneDeep(state.addressObjectDataList)

    _.forEach(items, (o) => {
      const itemIndex = _.findIndex(addressObjectDataList, {addr_obj_id: o.addr_obj_id})

      addressObjectDataList.splice(itemIndex, 1)
    })

    state.addressObjectDataList = Object.freeze(addressObjectDataList)
  // },
  //
  // // 주소 객체 조회
  // getAddressObjData (state, {result, addrType}) {
  //   // TAMS
  //   result = result[0]
  //   if (addrType.indexOf('host') > -1) {
  //     state.hostData = result
  //   }
  //
  //   if (addrType.indexOf('network') > -1) {
  //     state.networkData = result
  //   }
  //
  //   if (addrType.indexOf('group') > -1) {
  //     state.groupData = result
  //   }
  }
}

export const actions = {
  // 실행되는 메뉴 설정
  async setParentMenu ({commit, state}, data) {
    commit('setParentMenu', data)
  },

  // 주소 객체 초기화
  resetAddressObjData ({commit}) {
    commit('resetAddressObjData')
  },

  // 주소 객체 목록 조회 (ips용)
  async getAddressObjectList ({commit, dispatch, state, rootState}, {addrType, version, target, loadingShow = true, loadingHide = true} = {}) {
    let uri = ''

    // TAMS
    const
      // addrObjId = 0, // 주소 객체 아이디, 0 이면 전체 조회
      addrObjType = parseAddrObjectTypeNumber(addrType), // 주소 객체 유형, 1 호스트 객체, 2 네트워크 객체 (넷마스크), 3 네트워크 객체 (범위), 4 그룹 객체
      addrObjIpVerType = parseAddrObjectIpVersionType(version, addrType) // 주소 객체 아이피 버전 유형 1 IPv4, 2 IPv6, 3 공통
    uri = `${state.addressApi}?addr_obj_ip_ver_type=${addrObjIpVerType}&addr_obj_type_list=[${addrObjType}]`

    const {code, result} = await this.$axios.$get(uri, {loadingShow, loadingHide})

    if (code === 'ok') {
      if (addrObjType !== 4) { // group: 4
        commit('setAddressObjectList', result)
      } else {
        commit('cm/objectSecProfile/object/ipsObjectSettings/groupObject/setGroupObjectDataList', {result, rootState}, {root: true})
      }
    }
  },

  // 주소 객체 삭제
  // TAMS 미사용 (단일, 다수 관계 없이 동일 API 사용)
  async deleteAddressObjectData ({commit, dispatch, state, rootState}, {loadingShow = true, loadingHide = true} = {}) {
    const objectType = rootState.cm.objectSecProfile.object.ipsObjectSettings.common.objectType
    const addrType = getAddrObjType(objectType)
    const version = (addrType === 'domain' ? 4 : getAddrVersion(objectType))
    const
      id = state.selectedData.addr_obj_id,
      url = `${addrType}/${version}/objects/ips/${id}`

    let
      code = void 0,
      cause = void 0

    try {
      const response = await this.$axios.$delete(`${objApiPrefix}/${url}`, {
        isReturnError: true,
        loadingShow,
        loadingHide
      })
      code = _.get(response, ['code'])
    } catch (e) {
      code = _.get(e, ['data', 'code'])
      cause = _.get(e, ['data', 'message'])
    }

    if (code === 'ok') {
      commit('deleteAddressObjectData', {objectId: id, addrType, rootState})
      // dispatch('common/common/setIsChanged', true, {root: true})
      commit('resetAddressSelectedData')
    } else if (Number(code) === 15010) { // 삭제 가능
      const selectedData = _.cloneDeep(state.selectedData)
      return {
        notDelete: [],
        forceDelete: [_.assign(selectedData, {cause: cause})]
      }
    } else {
      const selectedData = _.cloneDeep(state.selectedData)
      return {
        notDelete: [_.assign(selectedData, {cause: cause})],
        forceDelete: []
      }
    }
  },

  // 주소 객체 일괄 삭제
  // TAMS
  // 주소 그룹객체도 사용함.
  // 주소 그룹의 경우 groupObject의 store를 사용하여 표현하나 삭제 후 TAMS의 경우 GUI 작업 없이 다시 Reload 되기 때문에 문제 없음
  // 동일 API 중복으로 인한 유지관리 이원화를 막기 위해 같은 Action을 사용함.
  async deleteBatchAddressObjectData ({commit, dispatch, state, rootState}, {items, forceYn = 0} = {}) {
    // TAMS
    let
      url = `objects/ips/addr`,
      params = void 0,
      addrObjIdList = []
    const id = 'addr_obj_id'

    const selectedData = _.cloneDeep(items)
    if (_.size(selectedData) > 0) {
      addrObjIdList = _.map(selectedData, item => item[id])
    } else {
      addrObjIdList = [selectedData[id]]
    }
    if (_.size(addrObjIdList) === 1) {
      url += `/${addrObjIdList[0]}`
    } else {
      params = {
        items: addrObjIdList,
        force_yn: forceYn
      }
    }

    const res = await this.$axios.$delete(
      `${cmApiPrefix}/${url}`,
      {data: params},
      {successAlert: false}
    )

    if (res.code === 'ok') {
      commit('resetAddressSelectedData')
    }
    return res
  },

  // 주소 객체 조회
  // async getAddressObjData ({commit, state}, {addrType, version, objectId, loadingShow = true, loadingHide = true} = {}) {
  //   // TAMS
  //   const
  //     // addrObjId = id, // 주소 객체 아이디, 0 이면 전체 조회
  //     addrObjId = objectId || state.selectedData.addr_obj_id, // 주소 객체 아이디, 0 이면 전체 조회
  //     addrObjType = state.selectedData.addr_obj_type, // 주소 객체 유형, 1 호스트 객체, 2 네트워크 객체 (넷마스크), 3 네트워크 객체 (범위), 4 그룹 객체, 5 도메인 객체, 6 URI 객체 [1,2,3,4,5,6]
  //     addrObjIpVerType = state.selectedData.addr_obj_ip_ver_type, // 주소 객체 아이피 버전 유형 1 IPv4, 2 IPv6, 3 공통
  //     pageCnt = 0, // 페이지 당 건수
  //     pagePos = 0, // 조회 페이지, 시작페이지 0부터
  //     url = `${cmApiPrefix}/objects/ips/${addrObjType}/${addrObjIpVerType}`
  //
  //   const {code, result} = await this.$axios.$get(`${url}`, {loadingShow, loadingHide})
  //
  //   if (code === 'ok') {
  //     commit('getAddressObjData', {result, addrType})
  //   }
  // },

  // 주소 객체 참조 여부 상세 조회
  async getAddressDetailRefData ({commit, state, rootState}, {objectData, objectType, version, loadingShow = true, loadingHide = true} = {}) {
    let objId = void 0
    let url = void 0

    if (objectType === 'host' ||
      objectType === 'network') {
      objId = objectData.addr_obj_id
      url = `${objectType}/${version}/objects/ips/addr`
    }

    const {code, result} = await this.$axios.$get(`${objApiPrefix}/${url}/${objId}/ref`, {loadingShow, loadingHide})

    if (code === 'ok') {
      commit('cm/objectSecProfile/object/ipsObjectSettings/common/setUsedDetailData', result, {root: true})
    }
  },

  // ips 주소 객체 직접입력
  async setAddressObjectAuto ({commit, dispatch, state}, {param = {}, loading = false, successAlert = false} = {}) {
    let res = {code: 'ok'}

    try {
      const {code, result} = await this.$axios.$post(`${state.addressApi}-auto`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: code, reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  // ips 주소 객체 사용 여부
  async getAddressObjectUsed ({commit, state}, {objId = null, loading = false, successAlert = false} = {}) {
    let res = {code: 'ok'}

    try {
      const {code, result} = await this.$axios.$get(`${state.addressApi}/used/${objId}`, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  // },
  //
  // // ips 주소 객체 사용 여부
  // async addrDownload ({commit, state}, {param = null, loading = false, successAlert = false} = {}) {
  //   let res = {code: 'ok'}
  //
  //   try {
  //     const {code, result} = await this.$axios.$get(`${state.addressApi}/excel?addr_obj_ip_ver_type=${addrObjIpVerType}&addr_obj_type_list=[${addrObjType}]`, {loading, successAlert})
  //     if (code === 'ok') {
  //       res.result = result
  //     } else {
  //       res = {code: 'nok', reason: result.msg}
  //     }
  //   } catch (e) {
  //     res = {code: 'nok', reason: e}
  //   }
  //   return res
  }
}

export const getters = {}

export const strict = false
